import { useResourceFormContext } from "src/components/Form/hooks/useResourceFormContext.ts";

// todo: rename this hood. useFormAction coincides with react-router-dom useFormAction hook
export const useResourceFormAction = (): string => {
  const { action } = useResourceFormContext();
  return action;
};
